export class ActionsPermission {
  actTribunalCadastroDemandante = 9144;
  actTribunalCadastroDemandado = 9145;
  actTribunalCadastroTestemunha = 9146;
  actTribunalCadastroJuiz = 9147;
  actTribunalCadastroVigarioJudicial = 9148;
  actTribunalCadastroDefensorVinculo = 9149;
  actTribunalCadastroNotario = 9150;
  actTribunalCadastroPerito = 9151;
  actTribunalCadastroAssessor = 9152;
  actTribunalCadastroOutrosFormulaDuvida = 9153;
  actTribunalCadastroOutrosMotivoEncerramento = 9154;
  actTribunalCadastroOutrosOrganismoExterno = 9155;
  actTribunalCadastroOutrosQuestionario = 9156;
  actTribunalConfiguracoesParametrizacao = 9157;
  actTribunalProcessoNulidadeMatrimonialProcesso = 9158;
  actTribunalProcessoNulidadeMatrimonialTipoProcesso = 9159;
  actTribunalProcessoNulidadeMatrimonialGrupoProcesso = 9160;
  actTribunalProcessoOrdemRecebimento = 9161;
  actTribunalRelatorioGerencial = 9186;
  actTribunalCadastroOutrosForoCompetencia = 9207;
  actTribunalVinculoUsuarioPessoa = 9208;
  actTribunalModeloRelatorio = 9212;
  actTribunalProcessoNulidadeMatrimonialProcessoSearch = 9213;
  actTribunalRotaRomana = 9359;
  actTribunalRogatoriaRecebimento = 9359;
}
